// React imports.
import React from "react";

import { Assessment2bStepsEnum } from "../state";
import { Assessment2bHHDataReceivedStatusEnum } from "../state";


const Assessment2bTopParagraph = ({fuelType, state }) => (
    <div>
        {(fuelType.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.OverTargetNoIssues)
          &&  <p>
                <strong>
                    Status: No data reliability issue present!
                </strong>&nbsp;
                Your data recording and processing efforts for  {fuelType.description}   households
                have not been flagged because the number of households for whom you received
                data from your vendors is greater than or equal
                to  {fuelType.targetPercentHouseholdsCoveredString}   of your total assisted households.
            </p>
        }
        {(fuelType.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed
            && fuelType.numHouseholds===0)
        &&
            <p>
                <strong>
                    Status: N/A -
                </strong>&nbsp;
                You indicated that you DO NOT serve households that
                heat with &nbsp;{fuelType.description}. Therefore,
                there is no data here to check. Please click next.
            </p>
        }
        {(fuelType.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NotMeetTarget)
          &&
          <p>
              <strong>
                  Status: Potential data reliability issue present!  
              </strong>&nbsp;
              Your data recording and processing efforts for  &nbsp;{fuelType.description}   households
              have been flagged because the data you collected only covers  &nbsp;{fuelType.hHDataReceivedPercentString}   of
              your total assisted households. 
              <br/><br/>
              This indicates that your vendors may not be providing you with enough billing
              data to ensure your sample is representative of all LIHEAP households in your
              state/territory. 
          </p>
        }

        {(fuelType.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed)
          &&
          <p>
              <strong>
                  Status: N/A  
              </strong>&nbsp;
              Your electric baseload expenditure collection results for  &nbsp;{fuelType.description}   households
              were not flagged because you do not assist any households that heat with that fuel.
          </p>
        }

    </div>
);

export default Assessment2bTopParagraph;
